module.exports = __webpack_public_path__ + "assets/img/47@3x.1f9076f2.png";